export default __webpack_public_path__ + "static/media/non__dash__taxable_brokerage_account_light.647d23ad.png";